import React from "react";
import { useEffect, useRef } from "react";

const Advertise = ({ adClient, adSlot, adFormat = 'auto' }) => {

  const adRef = useRef(null);

  useEffect(() => {
    // Only initialize if the adsbygoogle script is available and element exists
    if (window.adsbygoogle && adRef.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        // Optionally log or ignore the error
        console.error("Error initializing adsbygoogle:", e);
        
      }
    }
  }, []);

  return (
    // <div className="col-lg-3 col-md-4">
    //   <div
    //     className="p-4 border rounded shadow"
    //     style={{ border: "1px solid black" }}
    //   >
    //     <h4 className="text-center">Advertisement</h4>
    //     <p className="text-center">
    //       Place your ad content here. This space can be used for banners,
    //       promotions, or other information.
    //     </p>
    //   </div>
    // </div>
    <ins className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client={adClient}
      data-ad-slot={adSlot}
      data-ad-format={adFormat}
      data-full-width-responsive="true"
    />
  );
};

export default Advertise;
